// Gallery thumb switching + zoom
document.querySelectorAll('.gallery-thumb').forEach(thumb=>{
  thumb.addEventListener('click',()=>{
    const src=thumb.querySelector('img').src;
    document.getElementById('gallery-main').src=src;
    document.querySelectorAll('.gallery-thumb').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
  });
});
document.getElementById('gallery-main').addEventListener('click',function(){this.classList.toggle('zoomed')});
// Swatch click — switch main image + filter gallery thumbs to only show selected color
document.querySelectorAll('.swatch-pill').forEach(s=>{
  s.addEventListener('click',()=>{
    document.querySelectorAll('.swatch-pill').forEach(x=>x.classList.remove('active'));
    s.classList.add('active');
    const src=s.getAttribute('data-img');
    if(src){document.getElementById('gallery-main').src=src}
    // Use swatch data-cid directly (avoids multi-word label parsing bugs like "GRIS FONCÉ" → "gris")
    const targetCid = s.getAttribute('data-cid') || s.textContent.trim().split(/\s+/)[0].toLowerCase();
    document.querySelectorAll('.gallery-thumb').forEach(t=>{
      const tcid = t.getAttribute('data-color');
      if(!tcid) return;
      t.style.display = (tcid === targetCid) ? '' : 'none';
      t.classList.remove('active');
    });
    // Sort visible thumbs — packshot/imprint first, lifestyle last (DOM reorder)
    const galleryThumbsContainer = document.getElementById('gallery-thumbs');
    if (galleryThumbsContainer) {
      const visible = Array.from(galleryThumbsContainer.querySelectorAll('.gallery-thumb')).filter(t => t.style.display !== 'none');
      visible.sort((a, b) => {
        const aSrc = (a.querySelector('img')||{}).src || '';
        const bSrc = (b.querySelector('img')||{}).src || '';
        const aIsLifestyle = aSrc.indexOf('/lifestyle/') !== -1 || aSrc.indexOf('lifestyle_') !== -1;
        const bIsLifestyle = bSrc.indexOf('/lifestyle/') !== -1 || bSrc.indexOf('lifestyle_') !== -1;
        if (aIsLifestyle === bIsLifestyle) return 0;
        return aIsLifestyle ? 1 : -1;
      });
      visible.forEach(t => galleryThumbsContainer.appendChild(t));
    }
    // Set first visible thumb as active
    const visibleThumbs = document.querySelectorAll('.gallery-thumb:not([style*="display:none"]):not([style*="display: none"])');
    if(visibleThumbs.length > 0) visibleThumbs[0].classList.add('active');
    // Recalculate thumb arrow visibility
    window.dispatchEvent(new Event('resize'));
  });
});
// Size click
document.querySelectorAll('.size-btn').forEach(b=>{
  b.addEventListener('click',()=>{
    document.querySelectorAll('.size-btn').forEach(x=>x.classList.remove('active'));
    b.classList.add('active');
  });
});
// ESC closes modal
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.getElementById('size-chart-modal').classList.remove('show')});
// Cross-sell swiper arrows
(function(){
  var row=document.getElementById('crosssell-row');if(!row)return;
  var prev=document.querySelector('[data-cs-prev]');
  var next=document.querySelector('[data-cs-next]');
  var card=row.querySelector('.cd');var step=card?card.offsetWidth*2:680;
  function update(){
    if(!prev||!next)return;
    prev.disabled=row.scrollLeft<=8;
    next.disabled=row.scrollLeft>=row.scrollWidth-row.clientWidth-8;
  }
  if(prev)prev.addEventListener('click',function(){row.scrollBy({left:-step,behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){row.scrollBy({left:step,behavior:'smooth'})});
  row.addEventListener('scroll',update);window.addEventListener('resize',update);update();
})();
// Thumbs swiper arrows (gallery-thumbs)
(function(){
  var row=document.getElementById('gallery-thumbs');if(!row)return;
  var prev=document.getElementById('thumbs-prev');
  var next=document.getElementById('thumbs-next');
  var step=84*3+30; // 3 thumbs + gaps
  function update(){
    if(!prev||!next)return;
    var hasOverflow=row.scrollWidth>row.clientWidth+4;
    prev.style.display=hasOverflow?'flex':'none';
    next.style.display=hasOverflow?'flex':'none';
    if(hasOverflow){
      prev.style.opacity=row.scrollLeft<=8?'.4':'1';
      next.style.opacity=row.scrollLeft>=row.scrollWidth-row.clientWidth-8?'.4':'1';
    }
  }
  if(prev)prev.addEventListener('click',function(){row.scrollBy({left:-step,behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){row.scrollBy({left:step,behavior:'smooth'})});
  row.addEventListener('scroll',update);window.addEventListener('resize',update);
  setTimeout(update,100);
})();

/* ---- PDP script block ---- */
(function(){
  var tabs=document.querySelectorAll('.chemin-tab');
  var panels=document.querySelectorAll('.chemin-panel');
  var dots=document.querySelectorAll('.chemins-dots .dot');
  var tabsContainer=document.querySelector('.chemins-tabs');
  if(!tabs.length)return;
  function selectTab(idx){
    idx=String(idx);
    tabs.forEach(function(t){t.setAttribute('aria-selected',t.getAttribute('data-tab')===idx?'true':'false')});
    panels.forEach(function(p){
      if(p.getAttribute('data-panel')===idx){p.removeAttribute('hidden')}
      else{p.setAttribute('hidden','')}
    });
    if(dots.length){
      dots.forEach(function(d){d.classList.toggle('active',d.getAttribute('data-dot')===idx)});
    }
  }
  tabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      selectTab(tab.getAttribute('data-tab'));
      if(window.innerWidth<=900 && tabsContainer){
        tab.scrollIntoView({behavior:'smooth',inline:'start',block:'nearest'});
      }
    });
  });
  dots.forEach(function(dot){
    dot.addEventListener('click',function(){
      var idx=dot.getAttribute('data-dot');
      if(tabs[idx]) tabs[idx].click();
    });
  });
  if(dots.length && tabsContainer && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting && e.intersectionRatio>=0.5){
          var idx=e.target.getAttribute('data-tab');
          dots.forEach(function(d){d.classList.toggle('active',d.getAttribute('data-dot')===idx)});
        }
      });
    },{root:tabsContainer,threshold:0.5});
    tabs.forEach(function(t){io.observe(t)});
  }
})();

/* ---- PDP script block ---- */
(function(){
  document.querySelectorAll('.swiper-block').forEach(function(block){
    var sw = block.querySelector('[data-detail-swiper]');
    var prev = block.querySelector('[data-detail-prev]');
    var next = block.querySelector('[data-detail-next]');
    if(!sw) return;
    if(prev) prev.addEventListener('click', function(){ sw.scrollBy({left: -sw.clientWidth*0.6, behavior: 'smooth'}); });
    if(next) next.addEventListener('click', function(){ sw.scrollBy({left: sw.clientWidth*0.6, behavior: 'smooth'}); });
  });
})();

/* ---- Zakeke variant sync (A++ buy-restore) ---- */
// Zakeke variant sync — PDP color/size selection → Zakeke form hidden input
(function(){
  if (!window.IMPRION_VARIANTS) return;
  function getActiveColor(){
    var el = document.querySelector('.swatch-pill.active');
    return el ? (el.getAttribute('data-cid') || '').toLowerCase() : null;
  }
  function getActiveSize(){
    var el = document.querySelector('.size-btn.active');
    return el ? el.getAttribute('data-size') : null;
  }
  function findVariantId(color, size){
    if (!color) return window.IMPRION_DEFAULT_VARIANT_ID;
    var match = window.IMPRION_VARIANTS.find(function(v){
      var c = (v.color || '').toLowerCase();
      return c === color && (!size || v.size === size);
    });
    return match ? match.id : window.IMPRION_DEFAULT_VARIANT_ID;
  }
  function syncForms(){
    var color = getActiveColor();
    var size = getActiveSize();
    var vid = findVariantId(color, size);
    // Extract numeric ID from GID gid://shopify/ProductVariant/XXX
    var numericId = vid.split('/').pop();
    document.querySelectorAll('form[action="/apps/zakeke"] input[name="id"]').forEach(function(input){
      input.value = numericId;
    });
  }
  // Initial sync (in case default differs)
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    syncForms();
  } else {
    document.addEventListener('DOMContentLoaded', syncForms);
  }
  // Hook swatch + size click
  document.addEventListener('click', function(e){
    var el = e.target.closest('.swatch-pill, .size-btn');
    if (!el) return;
    // Defer to next tick so .active class has been set by other handlers
    setTimeout(syncForms, 0);
  }, true);
  // Also sync on size-btn add/remove active
  document.querySelectorAll('.size-btn').forEach(function(b){
    b.addEventListener('click', function(){
      document.querySelectorAll('.size-btn').forEach(function(x){ x.classList.remove('active'); });
      this.classList.add('active');
      syncForms();
    });
  });
  // Expose for debug
  window.IMPRION_SYNC_VARIANT = syncForms;
})();